"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkCompanyEmployee = exports.isCompanyEmployee = void 0;
const __1 = require("..");
function isCompanyEmployee(object) {
    return checkCompanyEmployee(object).fulfilled;
}
exports.isCompanyEmployee = isCompanyEmployee;
function checkCompanyEmployee(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return (0, __1.check)(object, (0, __1.hasString)("id"), (0, __1.hasString)("employeeNumber").optional()).withOptions(options).explain();
}
exports.checkCompanyEmployee = checkCompanyEmployee;
//# sourceMappingURL=CompanyEmployee.js.map